import React, { useEffect } from "react";
import { useAppTranslations } from "./useAppTranslations";
import { GUEST_UID, useAllieAuth } from "./useAllieAuth";
import { useCompany } from "./useCompany";
import { config } from "../helpers";

const DEFAULT_MIN_UID_LENGTH = 5;

export const useTracking = () => {
  const { loggedUser } = useAllieAuth();
  const { company } = useCompany();
  const { GUEST } = useAppTranslations();

  const tracker = (window as any).Amplitude;

  useEffect(() => {
    config.TRACKING_ENABLED && tracker?.init(
      config.TRACKING_API_KEY,
      {
        defaultTracking: true,
        apiEndpoint: config.TRACKING_API_URL,
      },
    );
  }, [tracker]);

  useEffect(() => {
    if (loggedUser && !isNaN(loggedUser.id)) {
        tracker.setUserId(
          loggedUser.id === GUEST_UID
          ? GUEST
          : `${loggedUser.id}`.padStart(DEFAULT_MIN_UID_LENGTH, '0'));

        const identifyEvent = new tracker.Identify();
        identifyEvent.setOnce('role', loggedUser.role);
        tracker.identify(identifyEvent);
    }
  }, [loggedUser]);

  useEffect(() => {
    if (company) {
      const identifyEvent = new tracker.Identify();
      identifyEvent.setOnce('company', company.id);
      tracker.identify(identifyEvent);
    }
  }, [company]);

  return { tracker };
}
